define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/dom-class",
    "dojo/dom-construct",
    "dojo/query",
    "dojo/on",
    "dojo/dom",
    "dijit/form/Button",
    "csi",
    "csi/_base/underscore",
    "csi/action",
    "csi/util",
    "csi/html",
    "csi/locale",
    "csi/comm/PostRequest",
    "csi/html/Widget"
], function(declare,lang,domClass,domConstruct,query,on,dom,Button,csi,_,csiAction,util,
            html,locale,PostRequest,Widget) {

    return declare(Widget, {

        /** @property {blob} iframeSrc - The iframe source represented by the response data */
        iframeSrc: null,

        /** @property {string} iframeId - The UUID of the iframe element */
        iframeId: null,

        /** @property {URL} blobUrl - The URL which is generated from the response data */
        blobUrl: null,

        /** @property {string} connector - The name (Connector field in C8) of the MicroServiceConnector used */
        connector: null,

        /** @property {string} mimeType - The mimeType of the expected response */
        mimeType: null,

        /** @property {PostRequest} apiRequest - The PostRequest which fetches data from the external API */
        apiRequest: null,

        /** @property {string} frameStyle -  The iframe style CSS value */
        frameStyle: null,

        /**
         * Renders the response inside the iframe
         * @param {XHR} response
         */
        renderResponse: function(/*Response*/response){

            const blob = new Blob([response.data], {type: this.mimeType});
            this.blobUrl = window.URL.createObjectURL(blob);

            const iframe = domConstruct.create("iframe", {
                "style": this.frameStyle,
                src: this.blobUrl
            }, this.containerNode);

            this.iframeId = util.uuid();
            iframe.id = this.iframeId;
            URL.revokeObjectURL(this.blobUrl);
        },

        /**
         * Event for a refresh button, re-issues the same PostRequest
         */
        refreshIframe: function (e) {
            if(this.apiRequest) {
                this.apiRequest.post().then(response => this._handleOnRefresh(response));
            }
        },

        /**
         * Handles the iframe content refresh
         * @param {XHR} response
         */
        _handleOnRefresh: function (response) {
            if (response && response.data) {
                const blob = new Blob([response.data], {type: this.mimeType});
                URL.revokeObjectURL(this.blobUrl);
                this.blobUrl = window.URL.createObjectURL(blob);
                const iframe = dom.byId(this.iframeId);
                iframe.src = this.blobUrl;
            }
        },

        _processDeferreds: function() {

            this.apiRequest = new PostRequest("SiteAdmin", "SubmitUrlCollectionAndHandleResponse")
                .addParameter("AddURLs", this.urlRoot)
                .addParameter("Connector", this.connector)
                .addParameter("MimeType", this.mimeType);

            return this.apiRequest.post().then(response => this.renderResponse(response));
        }
    });
});